import { StyleSheet, View } from 'react-native';
import { ActivityIndicator, Chip, useTheme } from 'react-native-paper';

import { NotificationDot } from '@/components/atoms/indicator';

const STATUS_DOT_SIZE = 12;

interface ContactStatusChipProps {
  readonly label: string;
  readonly color: string | null | undefined;
  readonly saving: boolean;
  readonly onPress: () => void;
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
  },
});

const ChipColorIcon = ({ color }: { readonly color: string }) => (
  <View style={styles.container}>
    <NotificationDot color={color} size={STATUS_DOT_SIZE} />
  </View>
);

export const ContactStatusChip = ({ label, color, saving, onPress }: ContactStatusChipProps) => {
  const theme = useTheme();

  const chipIcon = saving
    ? undefined
    : color
      ? () => <ChipColorIcon color={color} />
      : 'tag-outline';

  return (
    <View style={styles.container}>
      <Chip
        icon={chipIcon}
        disabled={saving}
        mode="outlined"
        textStyle={{ color: theme.colors.onSurface }}
        onPress={onPress}>
        {saving ? <ActivityIndicator size={12} /> : label}
      </Chip>
    </View>
  );
};
